<div class="tabbable__body rounded-top-right no-margin">
  <h3>Här kan du administrera prislistorna som styr priserna på produkterna i WOO&nbsp;Manager</h3>

  <div class="button-filter-container">
    <button class="button primary-1" (click)="showNew()" [scrollTo]="newPriceListPanel">Ny prislista</button>
  </div>
  <div class="sticky-header">
    <h3>Existerande prislistor</h3>
  </div>

  <app-woo-table [data]="priceLists" [loaderTpl]="loader">
    <woo-table-column name="priceList" header="Period">
      <ng-template let-cell>{{ getLabel(cell.row) }}</ng-template>
    </woo-table-column>
    <woo-table-column name="created_at" header="Skapad">
      <ng-template let-cell>{{ cell.value | date : 'yyyy-MM-dd HH:mm'}}</ng-template>
    </woo-table-column>
    <woo-table-column name="updated_at" header="Uppdaterad">
      <ng-template let-cell>{{ cell.value | date : 'yyyy-MM-dd HH:mm'}}</ng-template>
    </woo-table-column>
    <woo-table-column name="priceList" header="">
      <ng-template let-cell>
        <div class="d-flex justify-content-end w-100">
          <button
            class="button margin--none"
            [routerLink]="['/products', 'pricelist', cell.row.id]"
          >
          <span class="icon-edit icon__semi-medium margin-right--1x"></span>
          Redigera
        </button>
        </div>
      </ng-template>
    </woo-table-column>
  </app-woo-table>

  <div
    #newPriceListPicker
    [ngClass]="{ away: !show.newPriceListPicker && !show.newPriceListForm }"
  >
    @if (show.newPriceListPicker) {
      <div class="sub-card col-12">
        <h3>Skapa ny prislista</h3>

        <select-pricelist-form
          [priceLists]="priceLists"
          (onSubmit)="templatePricelistFrom($event.priceList, $event.year, $event.priceListType, $event.priceListCurrency)"
          (onAbort)="hideNew()"
        ></select-pricelist-form>
      </div>
    }
  </div>

  <div #newPriceListPanel>
    @if (show.newPriceListForm) {
      <div class="sub-card col-12">
        <edit-pricelist
          [newPriceList]="newPriceList"
          (onSubmit)="createPriceList($event)"
        ></edit-pricelist>
      </div>
    }
  </div>

  <ng-template #loader let-data>
    @if (loading) {
      <div class="d-flex justify-content-center align-items-center w-100">
        <dot-loader [large]="true"></dot-loader>
      </div>
    }
  </ng-template>
</div>
